<template>
  <div>
    <div class="flex flex-col p-4 items-center">
      <div class="w-full flex flex-col">
        <div class="w-full flex flex-row gap-4">
          <div class="w-full md:w-1/2 lg:w-1/4">
            <div
              class="flex flex-col bg-white rounded-lg shadow p-4 pl-4 border border-gray-100 mb-4"
            >
              <div class="flex flex-row justify-between items-center mb-2">
                <div class="flex flex-col">
                  <div
                    class="bg-purple-50 rounded-lg w-10 h-10 flex items-center justify-center mb-1"
                  >
                    <i class="bx bx-dollar text-purple-500 text-2xl"></i>
                  </div>
                  <h1 class="text-md text-gray-700 mb-1">
                    Ingresos Totales
                    <el-tooltip
                      content="Ingresos totales del periodo seleccionado"
                      placement="top"
                    >
                      <i
                        class="bx bx-info-circle text-blue-500 text-md pl-2 pt-0.5 cursor-pointer"
                      ></i>
                    </el-tooltip>
                  </h1>
                  <h2 class="text-xl font-extrabold">
                    {{ moneyFormat(widgetsData.totalSales) }}
                  </h2>
                </div>
                <div class="flex flex-row"></div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4">
            <div
              class="flex flex-col bg-white rounded-lg shadow p-4 pl-4 border border-gray-200 mb-4"
            >
              <div class="flex flex-row justify-between items-center mb-2">
                <div class="flex flex-col">
                  <div
                    class="bg-purple-50 rounded-lg w-10 h-10 flex items-center justify-center mb-1"
                  >
                    <i class="bx bx-box text-purple-500 text-2xl"></i>
                  </div>
                  <h1 class="text-sm md:text-md lg:text-md text-gray-700 mb-1">
                    Ordenes Completadas
                    <el-tooltip
                      content="Total de reparaciones completadas en el periodo seleccionado"
                      placement="top"
                    >
                      <i
                        class="bx bx-info-circle text-blue-500 text-md pl-2 pt-0.5 cursor-pointer"
                      ></i>
                    </el-tooltip>
                  </h1>
                  <h2 class="text-xl font-extrabold">
                    {{ widgetsData.totalOrdersCompleted }}
                  </h2>
                </div>
                <div class="flex flex-row"></div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4">
            <div
              class="flex flex-col bg-white rounded-lg shadow p-4 pl-4 border border-gray-200 mb-4"
            >
              <div class="flex flex-row justify-between items-center mb-2">
                <div class="flex flex-col">
                  <div
                    class="bg-purple-50 rounded-lg w-10 h-10 flex items-center justify-center mb-1"
                  >
                    <i class="bx bx-time text-purple-500 text-2xl"></i>
                  </div>
                  <h1 class="text-md text-gray-700 mb-1">
                    Tiempo Promedio
                    <el-tooltip
                      content="Tiempo promedio de reparaciones en el periodo seleccionado"
                      placement="top"
                    >
                      <i
                        class="bx bx-info-circle text-blue-500 text-md pl-2 pt-0.5 cursor-pointer"
                      ></i>
                    </el-tooltip>
                  </h1>
                  <h2 class="text-xl font-extrabold">
                    {{ widgetsData.averageTimeFromTicket.toLocaleString() }} hrs
                  </h2>
                </div>
                <div class="flex flex-row"></div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4">
            <div
              class="flex flex-col bg-white rounded-lg shadow p-4 pl-4 border border-gray-200 mb-4"
            >
              <div class="flex flex-row justify-between items-center mb-2">
                <div class="flex flex-col">
                  <div
                    class="bg-purple-50 rounded-lg w-10 h-10 flex items-center justify-center mb-1"
                  >
                    <i class="bx bx-dollar-circle text-purple-500 text-2xl"></i>
                  </div>
                  <h1 class="text-md text-gray-700 mb-1">
                    Ticket Promedio
                    <el-tooltip
                      content="Valor promedio por reparación en el periodo seleccionado"
                      placement="top"
                    >
                      <i
                        class="bx bx-info-circle text-blue-500 text-md pl-2 pt-0.5 cursor-pointer"
                      ></i>
                    </el-tooltip>
                  </h1>
                  <h2 class="text-xl font-extrabold">
                    {{ moneyFormat(widgetsData.averageTicket) }}
                  </h2>
                </div>
                <div class="flex flex-row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";
export default {
  name: "FinancesIndex",
  props: {
    widgetsData: {
      type: Object,
      default: () => ({
        totalSales: 0,
        averageTicket: 0,
        totalOrdersCompleted: 0,
        averageTimeFromTicket: 0,
      }),
    },
  },
  components: {},
  data() {
    return {
      customRange: [],
    };
  },
  computed: {},
  methods: {
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
